/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Schema de DATOS denormalizado para el Frontend.
 */
export interface VideoSceneDataResponse { 
    scene_id: string;
    play_definition_id: number;
    label: string;
    value: string;
    category: string;
    value_id: number;
}

